"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnderstandPeopleMasterYourself() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="224709" id="lets-solve-it" className="relative min-h-[80vh] w-full bg-background flex items-center overflow-hidden !p-0 !m-0 !h-[100px]" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className={`flex flex-col gap-12 lg:gap-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="w-full">
            <h1 className="font-default text-6xl md:text-8xl lg:text-[86px] leading-[1.1] tracking-tighter text-center">
              <span className="block text-foreground uppercase font-bold">Ready to Take</span>
              <span className="block text-foreground uppercase font-bold">
                Back Your Home?
              </span>
            </h1>
          </div>

          {}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {}
            <div className="hidden lg:block" aria-hidden="true"></div>

            {}
            
          </div>
        </div>
      </div>
    </section>;
}